import api from './base'

export default {
  login (data) {
    return api().post(`user/login`, data)
  },
  logout () {
    return api().delete(`user/logout`)
  }
}
